import {
  PostgrestError,
  PostgrestMaybeSingleResponse,
  PostgrestResponse,
  PostgrestSingleResponse,
} from "@supabase/postgrest-js";
import { QueryClient } from "@tanstack/react-query";
import type { AnyPostgrestResponse } from "@supabase-cache-helpers/postgrest-core";
import { buildQueryOpts } from "@supabase-cache-helpers/postgrest-react-query";

export const getPagination = (page: number, size: number) => {
  const limit = size ? +size : 3;
  const from = page ? page * limit : 0;
  const to = page ? from + size - 1 : size - 1;

  return { from, to };
};

/** Cached reads stay fresh so revisiting a screen does not flash a loading state. Mutations already patch the cache. */
export const QUERY_STALE_TIME_MS = 5 * 60 * 1000;
export const QUERY_GC_TIME_MS = 30 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME_MS,
      gcTime: QUERY_GC_TIME_MS,
    },
  },
});

function queryFetcher<Result>(
  query: PromiseLike<PostgrestSingleResponse<Result>>
): Promise<PostgrestSingleResponse<Result>>;

function queryFetcher<Result>(
  query: PromiseLike<PostgrestMaybeSingleResponse<Result>>
): Promise<PostgrestMaybeSingleResponse<Result>>;

function queryFetcher<Result>(
  query: PromiseLike<PostgrestResponse<Result>>
): Promise<AnyPostgrestResponse<Result>>;

function queryFetcher<Result>(
  query: PromiseLike<AnyPostgrestResponse<Result>>
): Promise<AnyPostgrestResponse<Result>> {
  const builtQuery = buildQueryOpts<Result>(query, { throwOnError: true });
  return queryClient.fetchQuery<AnyPostgrestResponse<Result>, PostgrestError>(
    builtQuery
  );
}

export { queryFetcher };
